import avaLogo from '@/assets/tokens/ava.png';
import bnbLogo from '@/assets/tokens/bnb.png';
import btcLogo from '@/assets/tokens/btc.png';
import ccdLogo from '@/assets/tokens/ccd.png';
import ethLogo from '@/assets/tokens/eth.png';
import hmtLogo from '@/assets/tokens/hmt.png';
import icbxLogo from '@/assets/tokens/icbx.png';
import mobLogo from '@/assets/tokens/mob.png';
import sentioLogo from '@/assets/tokens/sentio.png';
import usdcLogo from '@/assets/tokens/usdc.png';
import usdtLogo from '@/assets/tokens/usdt.png';
import vicLogo from '@/assets/tokens/vic.png';
import xinLogo from '@/assets/tokens/xin.png';
import type { TokenData } from '@/types';

export const TOKENS: TokenData[] = [
  {
    name: 'hmt',
    label: 'HMT',
    icon: hmtLogo,
  },
  {
    name: 'usdt',
    label: 'USDT0',
    icon: usdtLogo,
  },
  {
    name: 'usdc',
    label: 'USDC',
    icon: usdcLogo,
  },
  {
    name: 'btc',
    label: 'BTC',
    icon: btcLogo,
  },
  {
    name: 'eth',
    label: 'ETH',
    icon: ethLogo,
  },
  {
    name: 'bnb',
    label: 'BNB',
    icon: bnbLogo,
  },
  {
    name: 'husd',
    label: 'HUSD',
    icon: usdcLogo,
  },
  {
    name: 'xin',
    label: 'XIN',
    icon: xinLogo,
  },
  {
    name: 'icbx',
    label: 'ICBX',
    icon: icbxLogo,
  },
  {
    name: 'mob',
    label: 'MOB',
    icon: mobLogo,
  },
  {
    name: 'ccd',
    label: 'CCD',
    icon: ccdLogo,
  },
  {
    name: 'st',
    label: 'ST',
    icon: sentioLogo,
  },
  {
    name: 'vic',
    label: 'VIC',
    icon: vicLogo,
  },
  {
    name: 'ava',
    label: 'AVA',
    icon: avaLogo,
  },
];

const BASE_FUND_TOKENS = ['usdt', 'usdc'] as const;
const TESTNET_FUND_TOKENS = ['hmt'] as const;

export const FUND_TOKENS = [
  ...BASE_FUND_TOKENS,
  ...(import.meta.env.VITE_APP_WEB3_ENV === 'mainnet'
    ? []
    : TESTNET_FUND_TOKENS),
] as const;
export type FundToken = (typeof FUND_TOKENS)[number];
